/* ============================================================
   Flamel Analytics — Bridge de medición del Buscador de Tono IA
   Cliente: MyDollHair (vip.mydollhairshop.com)
   Generated: 2026-07-29 por flamel-analytics-dept
   Asset destino: assets/flamel-tf-ga4.js

   POR QUÉ EXISTE
   `tone-finder.js` ya emite 13 eventos al dataLayer (helper dl(), línea 152).
   Pero MDH NO tiene container de GTM (context.md §12: gtm_container_id "TBD")
   y el theme no tiene gtag (auditoría 2026-06-02: "0 gtag/GTM/GA/Meta").
   Es decir: hoy el buscador empuja eventos a un dataLayer que nadie lee.

   Este bridge es la capa de ENTREGA que falta. NO toca tone-finder.js.

   QUÉ HACE
   1. Instala gtag con G-EKE2Q9VP4M.
   2. Drena el dataLayer a GA4 — incluidos los eventos empujados ANTES de que
      este script cargue (replay). Sin el replay se pierde tf_open en layout
      inline, donde dl('tf_open') corre en el arranque del propio módulo.
   3. Cierra tres huecos del funnel sin tocar el widget:
      - tf_view      : impresión del CTA (IntersectionObserver sobre .tf-trigger).
                       Es el denominador de "cuántas usuarias VIERON el buscador".
      - tf_layout    : tf_open significa cosas distintas en modal (clic) vs inline
                       (carga de página). Se adjunta a todo para poder segmentar.
      - tf_session_id: une el recorrido de una misma usuaria dentro de la sesión.
   4. Espeja los eventos a Microsoft Clarity (project wpwh154srb, ya vivo) para
      poder filtrar grabaciones de sesiones que usaron el buscador.

   CÓMO DRENA (y por qué así)
   No basta con envolver `dataLayer.push`: cuando gtag.js termina de cargar
   REEMPLAZA `dataLayer.push` por el suyo, y a partir de ahí nuestro wrapper
   deja de existir. En modo gtag (sin container GTM) su procesador ignora los
   objetos {event:'...'}, así que los eventos posteriores se perderían EN
   SILENCIO — el fallo más caro posible aquí.
   Por eso drenamos con un CURSOR sobre el array (que sigue creciendo se lo
   quede quien se lo quede) + un wrapper para inmediatez + un poll de seguridad
   que garantiza la entrega aunque nos quiten el push. Idempotente por diseño:
   cada índice se procesa exactamente una vez.

   SI ALGÚN DÍA SE MONTA GTM: se retira este asset y ya está. Los dataLayer.push
   de tone-finder.js siguen sirviendo sin tocar una línea del widget.

   COMPAT: ES5+, sin dependencias. Mismos patrones que el bridge de Redi
   (clients/redifood/deliverables/2026-06-24/theme-hero-kit-events.js).
   ============================================================ */

(function () {
  "use strict";

  var MEASUREMENT_ID = "G-EKE2Q9VP4M"; /* Vip My Doll Hair — canónica (context.md §12) */
  var DEBUG = false; /* true durante QA: loguea cada evento reenviado */
  var POLL_MS = 1000; /* red de seguridad si nos reemplazan dataLayer.push */

  /* Eventos que reenviamos. Lista explícita a propósito: si el widget empieza a
     empujar algo nuevo al dataLayer, no queremos mandarlo a GA4 sin decidirlo. */
  var TF_EVENTS = [
    "tf_view",
    "tf_open",
    /* La pantalla de consejos pasó a ser OBLIGATORIA (10-sep). `tf_howto_open` conserva su
       significado de siempre —interés voluntario— porque solo lo emite el enlace "ver otra vez";
       si se emitiera también al pintar la pantalla obligatoria saltaría al 100% y partiría su
       histórico sin que nadie lo notara en el informe. */
    "tf_howto_open",
    "tf_howto_view",
    /* La métrica que de verdad importa de este cambio: tf_open → tf_howto_ack → tf_upload mide
       lo que cuesta en abandono obligar a ver los consejos. Sin ella se despliega a ciegas. */
    "tf_howto_ack",
    /* Salida a una persona desde el aviso legal del resultado. Es la vía de rescate cuando el
       match no convence, y mide cuánta falta hace. */
    "tf_whatsapp_click",
    "tf_upload",
    /* Los dos tramos de la barra. `tf_prepare` es el trabajo local (leer el color, codificar
       las fotos) y `tf_analyze` es la llamada a la IA, que solo ocurre si se cruza la puerta.
       La caída entre los dos ES el ahorro de tokens: cada abandono en la puerta es una
       llamada a Anthropic que no se ha pagado. */
    "tf_prepare",
    "tf_gate_view",
    "tf_gate_submit",
    "tf_analyze",
    "tf_invalid_image",
    "tf_result",
    "tf_alt_view",
    "tf_view_more",
    "tf_quickview_open",
    "tf_cta_click",
    "tf_add_to_cart",
    "tf_email_capture",
    "tf_feedback",
    /* Valoración de la clienta (👎/👍/😍). No confundir con `tf_feedback`, que es el
       👍/👎 de entrenamiento que solo ven las asesoras en modo ?tf_train=1. */
    "tf_rating",
    /* El matiz que elegía la clienta antes de analizar. La pregunta se retiró el 02-09; el
       evento ya no se emite y la entrada queda solo para no perder el histórico del informe. */
    "tf_tone_vibe",
    /* Sin este, una caída de Anthropic es invisible en GA4: el widget vuelve a "ready"
       con el botón de reintento y en el informe solo se ve un embudo que se estrecha. */
    "tf_analysis_error",
    /* Preselección del tono en el desplegable de la ficha: mide si el resultado llega
       de verdad al formulario de producto o la clienta lo elige a mano. */
    "tf_pdp_select",
    "add_to_cart"
  ];

  function isTracked(name) {
    for (var i = 0; i < TF_EVENTS.length; i++) if (TF_EVENTS[i] === name) return true;
    return false;
  }

  var nativePush = Array.prototype.push;
  window.dataLayer = window.dataLayer || [];

  /* ---------- gtag ---------- */
  /* El shim estándar de Google es `function gtag(){dataLayer.push(arguments)}`, y el
     detalle importa: cuando gtag.js termina de cargar SUSTITUYE dataLayer.push por su
     procesador, y esa es la única vía por la que un evento nuevo se transmite. Si
     aquí guardásemos una referencia al push nativo (o al de antes), los eventos
     posteriores a la carga se quedarían en el array sin que nadie los enviase —
     silenciosamente. Por eso resolvemos `window.dataLayer.push` EN CADA LLAMADA.

     Reentrar en nuestro propio wrapper es inofensivo: drain() tiene guarda de
     reentrada y forward() ignora los `arguments` (no tienen `.event` de tipo string). */
  function gtagShim() {
    window.dataLayer.push(arguments);
  }

  function ensureGtag() {
    if (!window.gtag) {
      window.gtag = gtagShim;
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(MEASUREMENT_ID);
      (document.head || document.documentElement).appendChild(s);
      window.gtag("js", new Date());
    }
    /* Configuramos SIEMPRE nuestro stream, incluso si otra app ya instaló gtag
       para otra propiedad: si no, nuestros eventos irían a la suya.

       send_page_view:false a propósito. Este bridge existe para entregar los
       eventos del Buscador de Tono, no para medir páginas vistas. La tienda ya
       tiene otra etiqueta de Google (GT-K8F8Z62B, de la app Google & YouTube)
       que manda page_view a esta misma property; si además lo mandáramos
       nosotros, inflaríamos las sesiones y las páginas vistas del cliente y
       corromperíamos su baseline. Un bridge de medición nunca debe alterar lo
       que ya se estaba midiendo. */
    window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
  }

  /* ---------- Clarity (no-op si no está) ---------- */
  function clarityEvent(name) {
    if (typeof window.clarity === "function") {
      try {
        window.clarity("event", name);
      } catch (e) {}
    }
  }

  /* ---------- sessionStorage helpers ---------- */
  var SS = window.sessionStorage;
  function ssGet(k) {
    try {
      return SS.getItem(k);
    } catch (e) {
      return null;
    }
  }
  function ssSet(k, v) {
    try {
      SS.setItem(k, v);
    } catch (e) {}
  }
  function once(key) {
    if (ssGet(key)) return false;
    ssSet(key, "1");
    return true; /* si sessionStorage falla ssGet devuelve null y dejamos pasar el
                    evento: preferimos un duplicado a perder la cima del funnel */
  }

  /* ---------- Contexto común a todos los eventos ---------- */
  /* placement/layout salen del JSON que imprime tf-widget.liquid. tone-finder.js
     ya mete `placement` en cada dl(), pero lo resolvemos también aquí para que
     tf_view (que emitimos nosotros) lo lleve igual. */
  var cfg = (function () {
    try {
      var el = document.getElementById("tf-config");
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  })();

  function sessionId() {
    var v = ssGet("flamel_tf_session_id");
    if (v) return v;
    /* Suficiente para agrupar una sesión. No es un identificador personal y no
       se cruza con nada fuera de GA4. */
    v = "tf" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    ssSet("flamel_tf_session_id", v);
    return v;
  }

  function enrich(params) {
    var out = {};
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k)) out[k] = params[k];
    }
    out.tf_session_id = sessionId();
    if (!out.placement) out.placement = cfg.placement || "";
    out.tf_layout = cfg.layout || "";
    return out;
  }

  /* ---------- Reenvío dataLayer -> GA4 ---------- */
  function forward(entry) {
    /* Ignora los `arguments` de gtag y cualquier cosa sin nombre de evento. */
    if (!entry || typeof entry !== "object") return;
    var name = entry.event;
    if (typeof name !== "string" || !isTracked(name)) return;

    var params = {};
    for (var k in entry) {
      if (k !== "event" && Object.prototype.hasOwnProperty.call(entry, k)) params[k] = entry[k];
    }
    params = enrich(params);

    if (window.gtag) window.gtag("event", name, params);
    clarityEvent(name);
    if (DEBUG) console.log("[Flamel TF] ->", name, params);
  }

  /* Cursor: cada índice del dataLayer se procesa exactamente una vez, da igual
     quién sea el dueño de .push en ese momento. */
  var cursor = 0;
  var draining = false;
  function drain() {
    if (draining) return; /* forward() empuja a dataLayer vía gtag: no reentrar */
    draining = true;
    try {
      var dl = window.dataLayer || [];
      while (cursor < dl.length) {
        var entry = dl[cursor];
        cursor++;
        forward(entry);
      }
    } finally {
      draining = false;
    }
  }

  ensureGtag();
  drain(); /* replay de lo empujado antes de que cargáramos */

  /* Fast path: entrega inmediata mientras el push sea nuestro. */
  window.dataLayer.push = function () {
    var r = nativePush.apply(this, arguments);
    drain();
    return r;
  };

  /* Red de seguridad: si gtag.js (o cualquier otro) nos reemplaza el push, el
     cursor sigue avanzando igual y nada se pierde. */
  setInterval(drain, POLL_MS);
  /* Y un último barrido al salir, para lo que quede en vuelo. */
  window.addEventListener("visibilitychange", function () {
    if (document.hidden) drain();
  });
  window.addEventListener("pagehide", drain);

  /* ========================================================
     HUECO — tf_view: impresión del CTA del buscador
     ========================================================
     tone-finder.js emite tf_open, que es el CLIC en el botón. Nadie mide
     cuántas usuarias LO VIERON, que es justo el denominador de la pregunta de
     negocio: "de las que abrieron el buscador, cuántas compraron".

     .tf-trigger es el botón de apertura en layout modal (tf-widget.liquid).
     En inline no hay trigger: el buscador ya está en página, así que observamos
     el contenedor #tf-root.
  */
  (function initView() {
    function fire(entry) {
      if (!once("flamel_tf_view")) return;
      /* Al dataLayer, no directo a gtag: así queda disponible igual que el resto
         si algún día hay GTM. */
      window.dataLayer.push({ event: "tf_view", tf_entry: entry, placement: cfg.placement || "" });
    }

    function bind() {
      /* OJO: hay MÁS DE UN .tf-trigger. El widget duplica el CTA para responsive
         (tf-ai-cta--mobile / tf-ai-cta--desktop) y oculta uno con display:none
         según el viewport. Con querySelector cogíamos siempre el primero — el de
         móvil — que en escritorio está oculto; un IntersectionObserver sobre un
         elemento display:none no dispara NUNCA, así que tf_view se perdía entero
         en escritorio y funcionaba en móvil. Un sesgo silencioso justo en el
         denominador del embudo.
         Los observamos TODOS: el oculto simplemente nunca intersecta, y once()
         garantiza un solo evento aunque haya varios visibles. */
      var els = document.querySelectorAll(".tf-trigger");
      if (!els.length) els = document.querySelectorAll("#tf-root");
      if (!els.length) return;

      if (typeof IntersectionObserver !== "function") {
        fire("no_observer");
        return;
      }
      var obs = new IntersectionObserver(
        function (entries) {
          for (var n = 0; n < entries.length; n++) {
            if (entries[n].isIntersecting) {
              fire("intersection");
              obs.disconnect();
              return;
            }
          }
        },
        { threshold: 0.5 }
      );
      for (var i = 0; i < els.length; i++) obs.observe(els[i]);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bind);
    } else {
      bind();
    }
  })();
})();
